import script from "./search-discover-cta.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-discover-cta.vue?vue&type=script&setup=true&lang=ts"

import "./search-discover-cta.vue?vue&type=style&index=0&id=3e1894a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e1894a6"]])

export default __exports__